export enum BonusTabType {
  Bonuses = 'bonuses',
  UserBonuses = 'user_bonuses',
}

export enum BonusStatus {
  Active = 'active',
  Pending = 'pending',
  AvailableAfterProjectFinish = 'available_after_project_finish',
}

export enum BonusExtraType {
  PromoCode = 'promoCode',
  Wishes = 'wishes',
}

export enum BonusActivationType {
  PromoCodePersonal = 'promoCodePersonal',
  PromoCodeCommon = 'promoCodeCommon',
  Macamp = 'macamp',
  Target = 'target',
}
